import { Alert, Button, Card, FieldBlock, Input } from '@orbind/ui'
import { useState, type FormEvent } from 'react'
import { api } from '../lib/api.ts'
import { OrbindLogo } from '../shell/OrbindLogo.tsx'
import './login.css'

const SENHA_MINIMA = 8

/** Última etapa do fluxo "esqueci minha senha" — o token vem por query string do e-mail. */
export function ResetPasswordPage() {
  const token = new URLSearchParams(window.location.search).get('token') ?? ''
  const [senha, setSenha] = useState('')
  const [confirmacao, setConfirmacao] = useState('')
  const [enviando, setEnviando] = useState(false)
  const [concluido, setConcluido] = useState(false)
  const [erro, setErro] = useState<string | null>(null)

  const naoConfere = confirmacao !== '' && senha !== confirmacao
  const podeSalvar = token !== '' && senha.length >= SENHA_MINIMA && senha === confirmacao && !enviando

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault()
    if (!podeSalvar) return
    setEnviando(true)
    setErro(null)
    try {
      await api.auth['reset-password'].$post({ json: { token, password: senha } })
      setConcluido(true)
    } catch {
      setErro('Este link não é mais válido — pode ter expirado ou já ter sido usado. Peça um novo.')
    } finally {
      setEnviando(false)
    }
  }

  return (
    <div className="ob-root login">
      <section className="login__brand" aria-hidden>
        <div className="login__logo">
          <OrbindLogo size={44} color="#FFFFFF" halo="var(--ob-primary)" />
        </div>
        <h1 className="login__brand-title">Orbind</h1>
      </section>

      <section className="login__panel">
        <Card className="login__card">
          {concluido ? (
            <>
              <h2 className="login__title">Senha redefinida</h2>
              <p className="login__subtitle">Já dá para entrar com a senha nova.</p>
              <Button variant="primary" onClick={() => (window.location.href = '/login')}>
                Ir para o login
              </Button>
            </>
          ) : token === '' ? (
            <>
              <h2 className="login__title">Link inválido</h2>
              <p className="login__subtitle">Este endereço não tem um token de redefinição.</p>
              <Button variant="ghost" onClick={() => (window.location.href = '/forgot-password')}>
                Pedir um link novo
              </Button>
            </>
          ) : (
            <>
              <h2 className="login__title">Escolha uma nova senha</h2>

              <form className="ob-stack" onSubmit={onSubmit} noValidate>
                {erro ? (
                  <Alert tone="danger" title="Não foi possível redefinir">
                    {erro}
                  </Alert>
                ) : null}

                <FieldBlock label="Nova senha" required hint={`Ao menos ${SENHA_MINIMA} caracteres.`}>
                  {({ id }) => (
                    <Input
                      id={id}
                      type="password"
                      autoFocus
                      autoComplete="new-password"
                      value={senha}
                      onChange={(e) => setSenha(e.target.value)}
                    />
                  )}
                </FieldBlock>

                <FieldBlock label="Confirmar nova senha" required error={naoConfere ? 'As senhas não conferem.' : null}>
                  {({ id, invalid }) => (
                    <Input
                      id={id}
                      type="password"
                      autoComplete="new-password"
                      invalid={invalid}
                      value={confirmacao}
                      onChange={(e) => setConfirmacao(e.target.value)}
                    />
                  )}
                </FieldBlock>

                <Button type="submit" variant="primary" loading={enviando} disabled={!podeSalvar}>
                  Redefinir senha
                </Button>
              </form>
            </>
          )}
        </Card>
      </section>
    </div>
  )
}
